import { useResolvedMedia } from './useResolvedMedia';

// For media with no failure state of its own: the authorised url once it is ready, otherwise
// nothing. A caller that must tell "still resolving" from "cannot be shown" uses useResolvedMedia.
export const useResolvedMediaUrl = (params: { url?: string; href?: string }): string | undefined => {
    const media = useResolvedMedia(params);
    return media.status === 'resolved' ? media.url : undefined;
};
